module.exports = __webpack_public_path__ + "static/img/Eight of Pentacles.a895247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Eight of Pentacles.jpg
// module id = 1262
// module chunks = 0